import React from 'react';
import styled from 'styled-components';

const StreamersSection = styled.section`
	padding: 8rem 0;
`

const StreamerDiv = styled.div`
	display: grid;
	grid-template-columns: repeat(12, minmax(0, 1fr));
	grid-gap: 4rem;
	margin-top: 8rem;

	transform: translateY(50px);
 	opacity: 0;	
	animation-name: fadeInUp;
	animation-duration: 0.6s;
	animation-iteration-count: 1;
	animation-fill-mode: forwards;
	animation-timing-function: cubic-bezier(.2,.3,0,1);
	animation-delay: 1s;
	backface-visibility: hidden;
    perspective: 100px;


	img {
		grid-column: 3 / span 2;
		grid-row: span 3;
		height: auto;
		width: 100%;
	}
	h2 {
		grid-column: 5 / span 4;
		font-size: 6rem;
	}
	p {
		grid-column: 5 / span 4;
		grid-row: 2;
		font-family: 'Karla';
		letter-spacing: 0;
		font-size: 1.8rem;
		line-height: 1.5em;
	}
	ul {
		list-style: none;
		padding: 0;
		grid-column: 9 / span 2;
		grid-row: 2;
		line-height: 1.5em;
	}
	ul > li:first-child {
		margin-bottom: 2rem;
	}

	@media(max-width: 1230px) {
		grid-gap: 0;
		grid-row-gap: 4rem;

		img {
			grid-column: 2 / span 2;
		}
		p, h2 {
			grid-column: 4 / span 5;
		},
		ul {
			grid-column: 9 / span 3;
		}
	}

	@media(max-width: 900px) {
		margin-top: 0;
		margin-bottom: 4rem;
		img {
			grid-row: 1;
			grid-column: 2 / -2;
		}
		h2 {
			grid-row: 2;
			grid-column: 2 / -2;
		}
		p {
			grid-row: 3;
			grid-column: 2 / -2;
			font-size: 1.6rem;
		}
		ul {
			grid-row: 4;
			grid-column: 2 / span 5;
		}
	}
`

const WatchButton = styled.a`
	grid-row: 1;
	grid-column: 9 / span 2;
	text-align: center;
	background: #FFCA77;
	color: #2C2E32;
	padding: 2rem;
	align-self: center;
	height: auto;
	transform: scale(1);
	transition: transform 0.3s cubic-bezier(.2,.3,0,1);
	backface-visibility: hidden;
    perspective: 100px;
	
	@media(max-width: 1230px) {
		grid-column: 9 / span 3;
	}
	@media(max-width: 900px) {
		grid-row: 4;
		grid-column: 7 / span 5;
	}

	&:hover {
		transform: scale(1.1);
	}


	&:after {
		display: none;
	}

`

const Streamer = ({streamer}) => (
	<StreamerDiv>
		<img src={streamer.image} alt={streamer.name}/>
		<h2>{streamer.name}</h2>
		<p>{streamer.bio}</p>
		<ul>
			<li>Social Links : </li>
			{streamer.links.map(link => (
				<li key={link.name}><a href={link.url} target="_blank">{link.name}</a></li>
			))}
		</ul>
		<WatchButton href={streamer.twitch_url} target="_blank">Watch Stream </WatchButton>
	</StreamerDiv>
)

const Streamers = ({data}) => (
	<StreamersSection id="streamers">
		{data.streamers.map(streamer => <Streamer key={streamer.name} streamer={streamer}/>)}
	</StreamersSection>
)

export default Streamers;



// WEBPACK FOOTER //
// ./src/compontents/streamers.js